import { Check, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const ResumePackages = () => {
  const openCheckoutLink = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <div className="bg-secondary/10 min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-br from-primary to-primary/80 text-primary-foreground py-24">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Results Driven Resumes</h1>
          <p className="text-xl opacity-90 max-w-2xl mx-auto">Choose the Resume Package that Best Suites You!</p>
        </div>
      </div>

      {/* Pricing Cards */}
      <div className="max-w-7xl mx-auto px-6 -mt-8 pb-16">
        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8">
          
          {/* Premium Package */}
          <div className="bg-background rounded-2xl shadow-lg overflow-hidden relative">
            <div className="p-6">
              <div className="text-center mb-6">
                <h2 className="text-xl font-bold text-foreground mb-2">Premium Package</h2>
                <div className="text-3xl font-bold text-primary mb-2">$295</div>
              </div>

              <div className="space-y-3 mb-6">
                <h3 className="font-semibold text-foreground text-sm border-b border-border pb-2">Resume Writing Revamp</h3>
                
                <div className="flex items-center gap-2 text-sm">
                  <div className="bg-gradient-to-r from-success to-success/80 rounded-full p-0.5">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-muted-foreground">Award-winning ATS Friendly Design</span>
                </div>

                <div className="flex items-center gap-2 text-sm">
                  <div className="bg-gradient-to-r from-success to-success/80 rounded-full p-0.5">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-muted-foreground">ATS Keyword Optimized Content</span>
                </div>

                <div className="flex items-center gap-2 text-sm">
                  <div className="bg-gradient-to-r from-success to-success/80 rounded-full p-0.5">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-muted-foreground">Perfect Grammar & Spelling</span>
                </div>

                <div className="flex items-center gap-2 text-sm">
                  <div className="bg-gradient-to-r from-success to-success/80 rounded-full p-0.5">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-muted-foreground">Updated Work History & Skills</span>
                </div>

                <div className="flex items-center gap-2 text-sm">
                  <div className="bg-gradient-to-r from-success to-success/80 rounded-full p-0.5">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-muted-foreground">Powerful Accomplishment Statements</span>
                </div>

                <div className="flex items-center gap-2 text-sm">
                  <div className="w-4 h-4 rounded-full bg-destructive/20 flex items-center justify-center">
                    <X className="w-3 h-3 text-destructive" />
                  </div>
                  <span className="text-muted-foreground">Career Highlights Section</span>
                </div>

                <div className="flex items-center gap-2 text-sm">
                  <div className="w-4 h-4 rounded-full bg-destructive/20 flex items-center justify-center">
                    <X className="w-3 h-3 text-destructive" />
                  </div>
                  <span className="text-muted-foreground">Executive Branding</span>
                </div>

                <h3 className="font-semibold text-foreground text-sm border-b border-border pb-2 pt-4">Extra Resume Writing Perks</h3>

                <div className="flex items-center gap-2 text-sm">
                  <div className="bg-gradient-to-r from-success to-success/80 rounded-full p-0.5">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-muted-foreground">Keyword Optimized Cover Letter</span>
                </div>

                {[
                  "60-Day Free Trial of TailorWiz",
                  "LinkedIn Profile Revamp", 
                  "3 Custom-Tailored Resumes",
                  "Outreach, Cover & Thank You Letters",
                  "Industry/Occupation Targeting",
                  "Career Story Telling",
                  "Job Interviews Masterclass",
                  "Executive Biography",
                  "JobIntel 360 Suite Access"
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 text-sm">
                    <div className="w-4 h-4 rounded-full bg-destructive/20 flex items-center justify-center">
                      <X className="w-3 h-3 text-destructive" />
                    </div>
                    <span className="text-muted-foreground">{item}</span>
                  </div>
                ))}
              </div>

              <Button 
                onClick={() => openCheckoutLink('https://www.paypal.com/ncp/payment/PLB-3GCRSVLA4FNX')}
                className="w-full bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 text-primary-foreground font-semibold py-3 px-4 rounded-xl text-sm transition-all duration-300 hover:transform hover:-translate-y-1"
              >
                Get Started - $295
              </Button>
            </div>
          </div>

          {/* Professional Package */}
          <div className="bg-background rounded-2xl shadow-lg overflow-hidden relative border-2 border-destructive -mt-12">
            <div className="bg-destructive text-destructive-foreground text-center py-2 text-sm font-bold">
              MOST POPULAR
            </div>
            
            <div className="p-6">
              <div className="text-center mb-6 mt-4">
                <h2 className="text-xl font-bold text-foreground mb-2">Professional Package</h2>
                <div className="text-3xl font-bold text-destructive mb-2">$495</div>
              </div>

              <div className="space-y-3 mb-6">
                <h3 className="font-semibold text-foreground text-sm border-b border-border pb-2">Resume Writing Revamp</h3>
                
                {[
                  "Award-winning ATS Friendly Design",
                  "ATS Keyword Optimized Content",
                  "Perfect Grammar & Spelling",
                  "Updated Work History & Skills",
                  "Powerful Accomplishment Statements",
                  "Career Highlights Section"
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 text-sm">
                    <div className="bg-gradient-to-r from-success to-success/80 rounded-full p-0.5">
                      <Check className="w-3 h-3 text-white" />
                    </div>
                    <span className="text-muted-foreground">{item}</span>
                  </div>
                ))}

                <div className="flex items-center gap-2 text-sm">
                  <div className="w-4 h-4 rounded-full bg-destructive/20 flex items-center justify-center">
                    <X className="w-3 h-3 text-destructive" />
                  </div>
                  <span className="text-muted-foreground">Executive Branding</span>
                </div>

                <h3 className="font-semibold text-foreground text-sm border-b border-border pb-2 pt-4">Extra Resume Writing Perks</h3>

                {[
                  "Keyword Optimized Cover Letter",
                  "60-Day Free Trial of TailorWiz",
                  "LinkedIn Profile Revamp",
                  "3 Custom-Tailored Resumes",
                  "Outreach, Cover & Thank You Letters",
                  "Industry/Occupation Targeting",
                  "Career Story Telling"
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 text-sm">
                    <div className="bg-gradient-to-r from-success to-success/80 rounded-full p-0.5">
                      <Check className="w-3 h-3 text-white" />
                    </div>
                    <span className="text-muted-foreground">{item}</span>
                  </div>
                ))}

                {[
                  "Job Interviews Masterclass",
                  "Executive Biography",
                  "JobIntel 360 Suite Access"
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 text-sm">
                    <div className="w-4 h-4 rounded-full bg-destructive/20 flex items-center justify-center">
                      <X className="w-3 h-3 text-destructive" />
                    </div>
                    <span className="text-muted-foreground">{item}</span>
                  </div>
                ))}
              </div>

              <Button 
                onClick={() => openCheckoutLink('https://www.paypal.com/ncp/payment/PLB-B59TRSGNBQGJ')}
                className="w-full bg-gradient-to-r from-destructive to-destructive/80 hover:from-destructive/90 hover:to-destructive/70 text-destructive-foreground font-semibold py-3 px-4 rounded-xl text-sm transition-all duration-300 hover:transform hover:-translate-y-1"
              >
                Get Started - $495
              </Button>
            </div>
          </div>

          {/* Elite+/Executive Package */}
          <div className="bg-background rounded-2xl shadow-lg overflow-hidden relative">
            <div className="p-6">
              <div className="text-center mb-6">
                <h2 className="text-xl font-bold text-foreground mb-2">Elite+/Executive Package</h2>
                <div className="text-3xl font-bold text-purple-600 mb-2">$895</div>
              </div>

              <div className="space-y-3 mb-6">
                <h3 className="font-semibold text-foreground text-sm border-b border-border pb-2">Resume Writing Revamp</h3>
                
                {[
                  "Award-winning ATS Friendly Design",
                  "ATS Keyword Optimized Content", 
                  "Perfect Grammar & Spelling",
                  "Updated Work History & Skills",
                  "Powerful Accomplishment Statements",
                  "Career Highlights Section",
                  "Executive Branding"
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 text-sm">
                    <div className="bg-gradient-to-r from-success to-success/80 rounded-full p-0.5">
                      <Check className="w-3 h-3 text-white" />
                    </div>
                    <span className="text-muted-foreground">{item}</span>
                  </div>
                ))}

                <h3 className="font-semibold text-foreground text-sm border-b border-border pb-2 pt-4">Extra Resume Writing Perks</h3>

                {[
                  "Keyword Optimized Cover Letter",
                  "120-Day Free Trial of TailorWiz",
                  "120-Day Pass to JobIntel 360 Suite",
                  "LinkedIn Profile Revamp",
                  "10 Custom-Tailored Resumes",
                  "Outreach, Cover & Thank You Letters",
                  "Industry/Occupation Targeting",
                  "Career Story Telling",
                  "Job Interviews Masterclass",
                  "Executive Biography"
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 text-sm">
                    <div className="bg-gradient-to-r from-success to-success/80 rounded-full p-0.5">
                      <Check className="w-3 h-3 text-white" />
                    </div>
                    <span className="text-muted-foreground">{item}</span>
                  </div>
                ))}
              </div>

              <Button 
                onClick={() => openCheckoutLink('https://www.paypal.com/ncp/payment/PLB-J2FKKRR4Y3YW')}
                className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-4 rounded-xl text-sm transition-all duration-300 hover:transform hover:-translate-y-1"
              >
                Get Started - $895
              </Button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-16">
          <p className="text-muted-foreground">© 2025 Results Driven Resumes. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default ResumePackages;